/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box } from "@mui/material";
import React from "react";
import { filtersGridStyles } from "../../pages/reports/styles";

export const FilterContainer = ({ children }) => {
  return <Box sx={filtersGridStyles}>{children}</Box>;
};
